var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useQuiMenu } from "./QuiMenuContext.js";
import { QuiButton } from "../QuiButton/QuiButton.js";
import { WithTooltip } from "../_primitives/WithTooltip.js";
export function QuiMenuButton(_a) {
    var { tooltip, tooltipProps } = _a, props = __rest(_a, ["tooltip", "tooltipProps"]);
    const { refs, getReferenceProps, isOpen } = useQuiMenu();
    return (React.createElement(WithTooltip, { tooltip: tooltip, tooltipProps: tooltipProps },
        React.createElement(QuiButton, Object.assign({}, props, { active: isOpen, ref: refs.setReference }, getReferenceProps(), { type: "button" }))));
}
